const ExamCategoryType = {
	None: 0,
	YKS: 1,
	LGS: 2,
	KPSS:3,
	Maarif10:5
};

export default ExamCategoryType;